'use strict';

/**
 * @ngdoc component
 * @name mx.agent:mxMixedActionHandler
 * @module mx.agent
 * @description

 */
MixedActionHelper.$inject = [
	'$timeout',
	'$q',
	'mx.SolutionBuilderAgent.DialogOpenerService',
	'mx.shell.RoutingService',
	'mx.shell.ActionExecutorService',
	'mx.shell.ActionManagerService',
];
export default function MixedActionHelper($timeout, $q, dialogOpener, routingService, actionExecutorService, actionManagerService) {
	return {
		init: init,
	};

	function init(options) {
		var fn;

		switch (options.type) {
			case 'dialog':
				if (options.objectId) {
					fn = handlers().openEditDialog.bind({}, options.objectId, options.entityType, options.fullScreen);
				} else {
					fn = handlers().openNewDialog.bind({}, options.entityType, options.fullScreen);
				}
				break;
			case 'preview':
				fn = handlers().openPreview.bind({}, options.objectId, options.entityType, options.fullScreen);
				break;
			case 'action':
				fn = handlers().runAction.bind({}, options.action, options.actionContext, options.isLazy, options.parentView, options.presetFields, options.fullScreen);
				break;
		}

		return fn || function () {};
	}

	function handlers() {
		return {
			openNewDialog: function (entityType, fullScreen, presetFields) {
				dialogOpener.openNewDialog(entityType, null, null, fullScreen, presetFields);
			},
			openEditDialog: function (objectId, entityType, fullScreen, presetFields) {
				var context = {
					_id: objectId,
					_type: entityType,
					_name: '',
				};
				dialogOpener.openEditDialog(context, fullScreen, presetFields);
			},
			openPreview: function (objectId, entityType, fullScreen) {
				dialogOpener.openPreview(
					{
						EntityType: entityType,
						Id: objectId,
					},
					undefined,
					fullScreen
				);
			},
			runAction: function (actionId, actionContext, isLazy, parentView, presetFields, fullScreen) {
				if (actionId) {
					actionManagerService.getActionById(actionId).then(function (action) {
						if (action) {
							var context = actionContext;
							if (typeof context !== 'undefined') {
								context = Array.isArray(context) ? context : [context];
							}
							action.isLazy = isLazy;
							action.openInFullScreen = fullScreen;
							actionExecutorService.execute(action, context, parentView, presetFields).catch(mx.logCatch);
						}
					});
				}
			},
		};
	}
}
